<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { clientService } from "../../services";
import { required, email, sameAs, numeric } from "vuelidate/lib/validators";
import { error_message } from "../../Helper/helper";
import { success_message } from "../../Helper/helper";
import DatePicker from "vue2-datepicker";
/**
 * Add-product component
 */
export default {
  components: { Layout, PageHeader, DatePicker, clientService },
  data() {
    return {
        error: "",
        typeform: {
          app_name: "",
          vendor_name: "",
          vendor_number: "",
          email: "",
          password: "",
          confirm_password: "",
          address: "",
          subscription_plan_type: "",
          subscription_date: "",
          payment_link: "",
          is_single_restaurant: "",
          business_category: ""
      }
    };
  },
  validations: {
    typeform: {
      app_name: {
        required,
      },
      vendor_name: {
        required,
      },
      vendor_number: {
        required,
        numeric
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
      address:{
        required,
      },
      subscription_plan_type:{
        required,
      },
      subscription_date:{
        required,
      },
      payment_link:{
        required,
      },
      is_single_restaurant:{
        required,
      },
      business_category:{
        required,
      }
    },
  },
  methods: {
    addClient(){
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      }
      else{
        clientService.addClient(this.typeform)
        .then(response => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({name:'client-list'});
          } else {
            error_message(response.data.message);
          }
        });
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-user"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Add Client') }}</h4>
              <p><router-link :to="{ name: 'client-list'}">{{ trans.get('__JSON__.Client') }}</router-link> > {{ trans.get('__JSON__.Add Client') }}</p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="addClient">
        <!-- Client Info Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Client Info') }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                    <b-form-group
                        id="input-group-1"
                        :label="this.trans.get('__JSON__.Business Name')"
                        label-for="input-1"
                      >
                        <b-form-input
                          id="input-1"
                          name="app_name"
                          ref="app_name"
                          v-model="$v.typeform.app_name.$model"
                          type="text"
                          :placeholder="this.trans.get('__JSON__.Enter Business Name')"
                          :class="{ 'is-invalid':  $v.typeform.app_name.$error }"
                        ></b-form-input>
                        <div v-if="$v.typeform.app_name.$error" class="invalid-feedback">
                          <span
                            v-if="!$v.typeform.app_name.required"
                          >{{ trans.get('__JSON__.Please enter business name') }}</span>
                        </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Business Person Name')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="vendor_name"
                      ref="vendor_name"
                      v-model="$v.typeform.vendor_name.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Business Person name')"
                      :class="{ 'is-invalid':  $v.typeform.vendor_name.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.vendor_name.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.vendor_name.required"
                      >{{ trans.get('__JSON__.Please enter business person name') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Email')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="email"
                      ref="email"
                      v-model="$v.typeform.email.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter email')"
                      :class="{ 'is-invalid':  $v.typeform.email.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.email.required"
                      >{{ trans.get('__JSON__.Please enter email') }}</span>
                      <span
                        v-if="!$v.typeform.email.email"
                      >{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Contact Number')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="vendor_number"
                      ref="vendor_number"
                      v-model="$v.typeform.vendor_number.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Contact Number')"
                      :class="{ 'is-invalid':  $v.typeform.vendor_number.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.vendor_number.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.vendor_number.required"
                      >{{ trans.get('__JSON__.Please enter contact number') }}</span>
                      <span
                        v-if="!$v.typeform.vendor_number.numeric"
                      >{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Address')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="address"
                      ref="address"
                      v-model="$v.typeform.address.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Address')"
                      :class="{ 'is-invalid':  $v.typeform.address.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.address.required"
                      >{{ trans.get('__JSON__.Please enter address') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                    <b-form-group
                      id="input-group-2"
                      :label="this.trans.get('__JSON__.Password')"
                      label-for="input-2"
                    >
                      <b-form-input
                        id="input-2"
                        v-model="$v.typeform.password.$model"
                        name="password"
                        type="password"
                        :placeholder="this.trans.get('__JSON__.Enter password')"
                        :class="{ 'is-invalid':  $v.typeform.password.$error  }"
                      ></b-form-input>
                      <div v-if="$v.typeform.password.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.typeform.password.required"
                        >{{ trans.get('__JSON__.Please enter password')}}</span>
                      </div>
                    </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-2"
                    :label="this.trans.get('__JSON__.Confirm Password')"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="$v.typeform.confirm_password.$model"
                      name="confirm_password"
                      type="password"
                      :placeholder="this.trans.get('__JSON__.Re-enter password')"
                      :class="{ 'is-invalid':  $v.typeform.confirm_password.$error  }"
                    ></b-form-input>
                    <div v-if="$v.typeform.confirm_password.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.confirm_password.required"
                      >{{ trans.get('__JSON__.Please re enter your password')}}</span>
                      <span
                          v-else-if="!$v.typeform.confirm_password.sameAsPassword"
                        >{{ trans.get('__JSON__.Passwords must match') }}</span>
                    </div>
                  </b-form-group>
                </div>

              </div>
            </div>
          </div>
        <!-- Client Info End -->

        <!-- Plan Details Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Plan Details') }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">{{ trans.trans('__JSON__.Plan Type') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.typeform.subscription_plan_type.$model"
                      id="subscription_plan_type"
                      name="subscription_plan_type"
                      :class="{ 'is-invalid':  $v.typeform.subscription_plan_type.$error  }"
                    >
                      <option value="" selected>{{ trans.get('__JSON__.Select Plan Type') }}</option>
                      <option value="basic">{{ trans.get('__JSON__.Basic') }}</option>
                      <option value="plus">{{ trans.get('__JSON__.Plus') }}</option>
                      <option value="premium">{{ trans.get('__JSON__.Premium') }}</option>
                    </select>
                    <div v-if=" $v.typeform.subscription_plan_type.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.subscription_plan_type.required"
                      >{{ trans.trans('__JSON__.please select at least one type.') }}.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Subscription Start Date')"
                    label-for="input-1"
                  >
                  <date-picker v-model="$v.typeform.subscription_date.$model" :class="{ 'is-invalid':  $v.typeform.subscription_date.$error  }"></date-picker>
                    <div v-if="$v.typeform.subscription_date.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.subscription_date.required"
                      >{{ trans.get('__JSON__.Please enter subscription date') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Payment Link')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="payment_link"
                      v-model="$v.typeform.payment_link.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter payment link')"
                      :class="{ 'is-invalid':  $v.typeform.payment_link.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.payment_link.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.payment_link.required"
                      >{{ trans.get('__JSON__.Please enter payment link') }}</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">{{ trans.trans('__JSON__.Business Type') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.typeform.is_single_restaurant.$model"
                      id="is_single_restaurant"
                      name="is_single_restaurant"
                      :class="{ 'is-invalid':  $v.typeform.is_single_restaurant.$error  }"
                    >
                      <option value="" selected>{{ trans.get('__JSON__.Select Business Type') }}</option>
                      <option value="Yes">{{ trans.get('__JSON__.Single Vendor') }}</option>
                      <option value="No">{{ trans.get('__JSON__.Multivendor') }}</option>
                    </select>
                    <div v-if=" $v.typeform.is_single_restaurant.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.is_single_restaurant.required"
                      >{{ trans.trans('__JSON__.please select at least one business type.') }}.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">{{ trans.trans('__JSON__.Business Category') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.typeform.business_category.$model"
                      id="business_category"
                      name="business_category"
                      :class="{ 'is-invalid':  $v.typeform.business_category.$error  }"
                    >
                      <option value="" selected>{{ trans.get('__JSON__.Select Business Category') }}</option>
                      <option value="Food">{{ trans.get('__JSON__.Food Delivery Business') }}</option>
                      <option value="Grocery">{{ trans.get('__JSON__.Grocery Delivery Business') }}</option>
                      <option value="Both">{{  trans.get('__JSON__.Multi Delivery Business') }}</option>
                    </select>
                    <div v-if=" $v.typeform.business_category.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.business_category.required"
                      >{{ trans.trans('__JSON__.please select at least one business category.') }}.</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          
        <!-- Plan Details End -->

          <div class="row">
            <div class="col-sm-6">
              <button
                class="btn btn-primary mr-1 mt-3"
              >{{ trans.get('__JSON__.Add Client') }}</button>
              <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
